import { ServiceProvidingLocationMarkAsRemovedCommand } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { ServiceProvidingLocationRemoveLink } from '../../../common/ServiceProvidingLocationRemoveLink';
import { serviceProvidingLocationTranslationKeys } from '../../../../../translations';
import { ReceptionServiceAssignmentCheckEventInterceptor } from '../interceptors/ReceptionServiceAssignmentCheckEventInterceptor';

type ServiceProvidingLocationRemoveCellProps = {
   readonly serviceProvidingLocationId: number;
   readonly serviceProvidingLocationName: string;
   readonly locationCode: string;
   readonly disabled: boolean;
   readonly onRemoved: PromiseVoidFunction;
};

export const ServiceProvidingLocationRemoveCell = (props: ServiceProvidingLocationRemoveCellProps): JSX.Element => {
   const { executeAsync: markAsRemoved } = useCqrsCommand<void, void>(
      () => {
         const command = new ServiceProvidingLocationMarkAsRemovedCommand();
         command.id = props.serviceProvidingLocationId;
         return command;
      },
      {
         onSuccess: () => {
            props.onRemoved();
            dispatchSnackbarPositiveEvent(serviceProvidingLocationTranslationKeys.serviceProvidingLocationWasRemoved);
         },
      }
   );

   return (
      <ReceptionServiceAssignmentCheckEventInterceptor serviceLocationId={props.serviceProvidingLocationId}>
         <ServiceProvidingLocationRemoveLink
            locationCode={props.locationCode}
            serviceProvidingLocationName={props.serviceProvidingLocationName}
            onRemoved={markAsRemoved}
            disabled={props.disabled}
         />
      </ReceptionServiceAssignmentCheckEventInterceptor>
   );
};
